import { useEffect, useState } from 'react';
import _ from '@lodash';
import { Controller, useFormContext } from 'react-hook-form';
import EditFormHelper from './EditFormHelper';

function EditForm(props) {
    const methods = useFormContext();
    const { control, reset, watch } = methods;
    const [fields, setFields] = useState(null);
    const [data, setData] = useState(null);
    const watchAllFields = watch();
    const [tabList, setTabList] = useState(null);

    useEffect(() => {
        if (data != null) {
            if (_.isFunction(props.config.tabList)) {
                setTabList(props.config.tabList(data));
            } else if (_.isArray(props.config.tabList)) {
                setTabList(props.config.tabList);
            } else {
                setTabList(null);
            }
            if (typeof props.config.fields === 'function') {
                setFields(props.config.fields(data));
            } else if (Array.isArray(props.config.fields)) {
                setFields([...props.config.fields]);
            } else {
                setFields([]);
            }
        } else {
            props.onInitialized(false);
        }
        if (!_.isUndefined(props.onDataChanged)) props.onDataChanged(data);
    }, [data]);

    useEffect(() => {
        if (!_.isUndefined(props.onTabList)) {
            const filteredTabList = tabList ? tabList.filter(tab => tab.key !== 'event') : null;
            props.onTabList(filteredTabList);
        }
    }, [tabList]);

    useEffect(() => {
        if (fields != null) {
            reset(data);
            props.onInitialized(true);
        } else {
            props.onInitialized(false);
        }
    }, [fields]);

    return (
        <div>
            <EditFormHelper config={props.config} id={props.id} onInitialized={_data => setData(_data)} onSuccessful={(resp, btnData) => props.onSuccessful(resp, btnData)} />
            {tabList && fields
                ? tabList.map((t, i) => (
                        <div key={t.key} className={props.tabValue !== i ? 'hidden' : ''}>
                            {fields.map(fieldRow =>
                                _.isUndefined(fieldRow.visibleIf) || fieldRow.visibleIf(watchAllFields, methods) ? (
                                    (i === 0 && _.isUndefined(fieldRow.tab)) || (Number.isFinite(fieldRow.tab) && i === fieldRow.tab) || t.key === fieldRow.tab ? (
                                        _.isUndefined(fieldRow.fields) || fieldRow.isControlledInput === false ? (
                                            <Controller
                                                key={fieldRow.key}
                                                name={fieldRow.key}
                                                control={control}
                                                render={({ field, fieldState }) => <fieldRow.component field={field} fieldState={fieldState} config={props.config} fieldConfig={fieldRow} />}
                                            />
                                        ) : (
                                            <fieldRow.component key={fieldRow.key} config={props.config} fieldConfig={fieldRow} />
                                        )
                                    ) : null
                                ) : null
                            )}
                        </div>
                  ))
                : fields
                ? fields.map(fieldRow =>
                        _.isUndefined(fieldRow.visibleIf) || fieldRow.visibleIf(watchAllFields, methods) ? (
                            _.isUndefined(fieldRow.fields) || fieldRow.isControlledInput === false ? (
                                <Controller
                                    key={fieldRow.key}
                                    name={fieldRow.key}
                                    control={control}
                                    render={({ field, fieldState }) => <fieldRow.component field={field} fieldState={fieldState} config={props.config} fieldConfig={fieldRow} />}
                                />
                            ) : (
                                <fieldRow.component key={fieldRow.key} config={props.config} fieldConfig={fieldRow} />
                            )
                        ) : null
                  )
                : null}
        </div>
    );
}

export default EditForm;
